import { YML_FILE_NAME } from '../const';

export function getCommitsPageURL(repoPath: string, revision = 'all'): string {
  return `https://bitbucket.org/${repoPath}/commits/${revision}`;
}

export function getRefPageURL(
  repoPath: string,
  refType = 'branch',
  refName = 'master',
  revision = '',
  line?: number
): string {
  const bitbucketRepositoryUrl = `https://bitbucket.org/${repoPath}`;
  const referenceType = refType ? refType.toLowerCase() : '';

  if (referenceType === 'branch' || referenceType === 'named_branch') {
    return `${bitbucketRepositoryUrl}/commits/branch/${encodeURIComponent(
      refName
    )}`;
  } else if (referenceType === 'custom') {
    const configurationFileUrl = `${bitbucketRepositoryUrl}/src/${encodeURIComponent(
      revision
    )}/${YML_FILE_NAME}`;
    if (line) {
      return `${configurationFileUrl}?fileviewer=file-view-default#${YML_FILE_NAME}-${line}`;
    }
    return configurationFileUrl;
  } else {
    return `${bitbucketRepositoryUrl}/commits/tag/${encodeURIComponent(
      refName
    )}`;
  }
}
